import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const chillHoursBetween32and45F: typeof valueTypeRenderers.chillHoursBetween32and45F = {
  label: () => unitConverter.chillHoursBetween32and45F().title(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.chillHoursBetween32and45F().title(),
      render: (n) => unitConverter.chillHoursBetween32and45F(n).valueAsString(),
    }),
}
